// Domain synonyms used to expand search queries.
// Example: searching for "pengar" also matches modules tagged "ekonomi".
// Add new mappings here without touching code — keys are query terms,
// values are tag-words that should match.

export const DOMAIN_SYNONYMS = {
  pengar:      ['ekonomi', 'finans', 'lön'],
  finance:     ['ekonomi', 'finans'],
  hms:         ['arbetsmiljö', 'säkerhet', 'skyddsrond'],
  säkerhet:    ['arbetsmiljö', 'skyddsrond', 'ia', 'tillbud'],
  byggdagbok:  ['dagbok'],
  fakturor:    ['ekonomi', 'betalplan'],
  iso:         ['kvalitet', 'miljö', 'arbetsmiljö', 'ledningssystem', '9001', '14001', '45001'],
  hållbarhet:  ['klimat', 'miljö', 'avfall'],
  mål:         ['kpi', 'scorecard', 'strategi'],
  personal:    ['hr', 'medarbetare', 'anställd'],
  upphandling: ['inköp', 'leverantörer', 'ue'],
  rapport:     ['reports', 'analytics', '360'],
};
